import React, { useState } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
import SelectOverview from '../Select/select';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { WalletWhiteIcon } from '../../common/components/icons/wallet_white';
import { GlobeWhiteIcon } from '../../common/components/icons/globe_white';

const languages = [
	{
		value: 'pl',
		label: 'PL',
	},
	{
		value: 'en',
		label: 'EN',
	},
	{
		value: 'de',
		label: 'DE',
	},
];

export const LanguageChange = () => {
	const { t } = useTranslation();
	const [selectedLanguage, setSelectedLanguage] = useState(
		languages.filter(language => i18n.language.includes(language.value))[0]
	);
	const changeLanguage = async (lang: { value: string; label: string }) => {
		setSelectedLanguage(languages.filter(() => i18n.language.includes(lang.value))[0]);

		await i18n.changeLanguage(lang.value);
	};

	return (
		<Flex alignItems="center">
			<Box maxH="14px">
				<GlobeWhiteIcon />
			</Box>
			<SelectOverview
				isSearchable={false}
				onChange={changeLanguage}
				options={languages.map(language => ({ value: language.value, label: language.label }))}
				value={selectedLanguage}
				placeholder={t('default.selectLanguage').toString()}
				placeholderColor="text"
			/>
		</Flex>
	);
};
